import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import { AuthUser } from 'types/User';
import { signInAsGuest, isSignedIn } from 'lib/Auth';
import captureException from 'lib/captureException';

export default async function signInAsGuestUseCase(email: string, uid?: string): Promise<AuthUser> {
  const credential = await signInAsGuest(email, uid);
  return extractDataFromFirebaseCredential(credential);
}

export async function ensureSignedIn(email: string): Promise<AuthUser | null> {
  if (isSignedIn()) {
    return null;
  }

  try {
    const userInfo = await signInAsGuestUseCase(email);
    return userInfo;
  } catch (e) {
    console.warn(`unable to authenticate user as guest: ${e}`);
    captureException(e);
    return null;
  }
}
